// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'development',
  adminToken: 'adminTokenDev',
  frontToken: 'frontTokenDev',
  frontURL: 'https:///dev.trustvms.com/',
  apiURL: 'https://dev.trustvms.com/api/',
  //apiURL: 'http://localhost:3000/api/',
  mapBox:
    'pk.eyJ1IjoibWFyaXVzLWFwb3N0b2wiLCJhIjoiY2t1ZHA2ZzczMWNzOTMybDk4b2JzNW94NSJ9.mQ5Jnoha7ZvfRuNVu9q2IA',
  passwordSettings: {
    min: 12,
    max: 40,
    text: 'Password should have between 12 and 40 characters and at least one number and one capital letter',
    regex: new RegExp(/^(?=.*?[A-Z])(?=.*?[0-9]).{12,40}$/),
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
